// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/reason-stop-machines",
  Short: "/pyr/reason-stop-machines/short",
  Detail: "/pyr/reason-stop-machines",
  Create: "/pyr/reason-stop-machines",
  Update: "/pyr/reason-stop-machines",
  Delete: "/pyr/reason-stop-machines",
};
